<template>
    <v-skeleton-loader
        v-if="loading"
        type="image"
        max-height="150"
    ></v-skeleton-loader>

    <v-card
        v-else-if="recent"
        @click="resumeOrContinueTryout"
        color="primary"
        dark
    >
        <div class="d-flex justify-space-between align-center">
            <div>
                <v-card-title>{{ recent.title }}</v-card-title>

                <v-card-subtitle v-if="recent.state === 'paused'">
                    Sedang dijeda, lanjut kerjakan
                </v-card-subtitle>

                <v-card-subtitle v-else>
                    Belum dijeda, segera lanjutkan
                </v-card-subtitle>
            </div>

            <div>
                <v-icon
                    class="mr-4"
                    x-large
                >
                    <template v-if="recent.state === 'paused'">
                        mdi-pause
                    </template>
                    <template v-else>mdi-play</template>
                </v-icon>
            </div>
        </div>
        <v-card-text>Tersisa {{ recent.remaining_questions }} soal</v-card-text>
    </v-card>

    <v-card
        v-else-if="next"
        :color="next.is_released ? 'primary' : 'blue-grey'"
        dark
        @click="openNextTryout"
    >
        <div class="d-flex justify-space-between align-center">
            <div>
                <v-card-title>{{ next.title }}</v-card-title>

                <v-card-subtitle v-if="next.is_released">
                    Kerjakan sekarang
                </v-card-subtitle>

                <v-card-subtitle v-else>Belum tersedia</v-card-subtitle>
            </div>

            <div>
                <v-icon
                    class="mr-4"
                    x-large
                >
                    <template v-if="next.is_released">
                        mdi-file-question-outline
                    </template>
                    <template v-else>mdi-calendar</template>
                </v-icon>
            </div>
        </div>

        <v-card-text>
            <template v-if="next.is_released">
                {{ next.question_count }} Soal, {{ next.minute_limit }} Menit
            </template>

            <template v-else>
                {{ next.released_at }}
            </template>
        </v-card-text>
    </v-card>

    <v-card
        v-else
        color="primary"
        dark
    >
        <div class="d-flex justify-space-between align-center">
            <div>
                <v-card-title>Selesai!</v-card-title>

                <v-card-subtitle>Semua sudah dikerjakan</v-card-subtitle>
            </div>

            <div>
                <v-icon
                    class="mr-4"
                    x-large
                >
                    mdi-check
                </v-icon>
            </div>
        </div>

        <v-card-text>Ukom Nakes</v-card-text>
    </v-card>
</template>

<script>
import moment, { parseFromServer } from '@/plugins/moment'

export default {
    data() {
        return {
            loading: true,
            recent: null,
            next: null,
        }
    },

    methods: {
        openNextTryout() {
            if (this.next.is_released) {
                this.$router.push({
                    name: 'tryout.prestart',
                    params: { hash: this.next.hash },
                })
            }
        },

        resumeOrContinueTryout() {
            if (this.recent.state == 'paused') {
                this.$tracking.event.tryout.resume(
                    `${this.recent.title} ${this.$store.get(
                        'enrollment/selected@title'
                    )}`
                )
            }

            this.$router.push({
                name: 'work',
                params: { history_hash: this.recent.history_hash },
            })
        },
    },

    created() {
        this.$api.get('history/recent').then((response) => {
            if (response.data.length === 0) {
                this.$api.get('tryout/next').then((response) => {
                    if (response.data.length !== 0) {
                        const released_at = parseFromServer(
                            response.data.released_at
                        )

                        this.next =
                            response.data.length === 0
                                ? null
                                : {
                                      ...response.data,
                                      released_at:
                                          released_at.formatShortDayAndTime(),
                                      is_released:
                                          moment().isAfter(released_at),
                                  }
                    }

                    this.loading = false
                })
            } else {
                this.recent = response.data
                this.loading = false
            }
        })
    },
}
</script>
